import React from 'react'
 
import ProductDetail from "../../component/ProductDetail";
import ProductFAQ from '../../component/ProductFAQ';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Bespoke() {
    
  const location = useLocation();
 
  const slug = location.pathname.split("/")[2];
  
  return ( 
    <div>
       <Helmet>
        <title>  </title>
        <meta name="description" content="" />
        <link rel="canonical" href="https://www.indianarmour.com/bespoke-solutions" />
      </Helmet>
    <section className="banner-bes">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="bes-text">
              <h1>Bespoke Solutions</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="breadcrumb-inner pt-3  pb-5">
      <div className="container">
        <nav >
          <ol className="breadcrumb mb-0 justify-content-start">
            <li className="breadcrumb-item"><a href="index.php">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Bespoke Solutions</li>
          </ol>
        </nav>
      </div>
    </section>
    <section className="integrated right-black-bg1">
      <div className="container">
        <div className="row co-reverse">
          <div className="col-lg-7 col-md-7 col-sm-12 col-12">
            <div className="integrated-text">
              <h2>Indian Armour is the world’s most vertically integrated manufacturing company, making us a very competitive and prosperous corporation that delivers bespoke services to our customers. As an established manufacturer of ballistic protection solutions, Indian Armour has stayed dedicated to employing cutting-edge technology to build products that are lighter, better, and more cost effective.
                <br />
                At Indian Armour, we work with both off-the-shelf and bespoke solutions since there is often a case for each option in any project. Our bespoke solutions are built specifically around the requirements of our customers and are designed for maximum safety in diverse operational conditions. Rather than conforming to a broader range of generic criteria, our customised services focus on the key deliverables required by the customer and execute on the specifics.<br />
                We enable you profit from our customized solutions that we helped develop and execute by using specially designed systems and a state-of-the-art manufacturing facility.</h2>
            </div>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-12">
            <div className="integrated-img">
              <img src="/images/integrate-sd.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="our-customer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="our-customer-text">
              <h2>Our Customer-Centric Approach</h2>
              <p>Your solution will be completely tailored to your requirements. Understanding the expectations of our customers and end-users is key to developing a viable solution. We make certain that we thoroughly grasp our clients’ expectations through effective communication, not just at the start of the journey but also throughout the delivery process. We focus on their underlying needs while ensuring that our solution is in line with their requirements.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    
  </div>
  )
}

export default Bespoke